import { render, staticRenderFns } from "./GeneralScreenDashboard.vue?vue&type=template&id=9fe2ee46&"
import script from "./GeneralScreenDashboard.vue?vue&type=script&lang=js&"
export * from "./GeneralScreenDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports